var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.20371V1.5625C0 1.1481 0.16462 0.750671 0.457646 0.457646C0.750671 0.16462 1.1481 0 1.5625 0L23.4375 0C23.8519 0 24.2493 0.16462 24.5424 0.457646C24.8354 0.750671 25 1.1481 25 1.5625V2.20371L12.5 10.0162L0 2.20371ZM12.9141 11.6002C12.7899 11.6777 12.6464 11.7188 12.5 11.7188C12.3536 11.7188 12.2101 11.6777 12.0859 11.6002L0 4.04629V17.1875C0 17.6019 0.16462 17.9993 0.457646 18.2924C0.750671 18.5854 1.1481 18.75 1.5625 18.75H23.4375C23.8519 18.75 24.2493 18.5854 24.5424 18.2924C24.8354 17.9993 25 17.6019 25 17.1875V4.04629L12.9141 11.6002Z",
    fill: "#4982F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.42f801b60d7da641080cee44e553697c.svg";
export { ForwardRef as ReactComponent };